{
  "enum": {
    "ExcIceCorpactionsV1ActionStatus": {
      "ACTIVE": "Active",
      "DELETED": "Deleted",
      "UNSPECIFIED": "Unspecified"
    },
    "ExcIceCorpactionsV1ActionType": {
      "MANDATORY": "Mandatory",
      "MANDATORY_WITH_CHOICE": "Mandatory with Choice",
      "UNSPECIFIED": "Unspecified",
      "VOLUNTARY": "Voluntary"
    },
    "ExcIceCorpactionsV1AnnouncementStatus": {
      "APPROVAL": "Approval",
      "COMPLETED_DEAL": "Completed Deal",
      "DOES_NOT_APPLY": "Does Not Apply",
      "EXPIRATION": "Expiration",
      "EXPIRED": "Expired",
      "EXTENDED": "Extended",
      "EXTENSION": "Extension",
      "FINAL": "Final",
      "PRELIMINARY": "Preliminary",
      "REJECTED": "Rejected",
      "REVISED_OFFER": "Revised Offer",
      "TERMINATED": "Terminated",
      "UNSPECIFIED": "Unspecified"
    },
    "ExcIceCorpactionsV1EventStatus": {
      "DELETED": "Deleted",
      "NEW": "New",
      "UNSPECIFIED": "Unspecified",
      "UPDATED": "Updated"
    }
  },
  "filterEnum": {
    "ExcIceCorpactionsV1ActionQueryServiceActionListFilterableFields": {
      "eventId": "Event ID",
      "status": "Status"
    }
  },
  "oneOf": {
    "ExcIceCorpactionsV1ActionEventType": {
      "deleted": "Deleted",
      "newOrUpdated": "New or Updated"
    },
    "ExcIceCorpactionsV1EventType": {
      "capitalChange": "Capital Change",
      "conversionList": "Conversion List",
      "dividend": "Dividend",
      "earningsList": "Earnings List",
      "identifierChangeList": "Identifier Change List",
      "informationAnnouncement": "Information Announcement",
      "listingList": "Listing List",
      "mergerAcquisitionList": "Merger Acquisition List",
      "outstandingSharesList": "Outstanding Shares List",
      "payment": "Payment",
      "redemptionList": "Redemption List",
      "repurchaseList": "Repurchase List",
      "shareholderMeeting": "Shareholder Meeting"
    }
  },
  "sortEnum": {
    "ExcIceCorpactionsV1ActionQueryServiceActionListSortableFields": {
      "metadata": {
        "createdAt": "Created At",
        "updatedAt": "Updated At"
      }
    }
  }
}